import { FormCardSelect, Option } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import {
  useFormItem,
  useNextDisabled,
  useNextLoading,
  useOnNextClick,
} from '@/providers'
import { keys } from 'ramda'
import { useTranslation } from 'react-i18next'
import { useSaveAssessmentStep } from '../helpers'
import { JSX } from 'react'

interface OptionsMessages {
  [key: string]: string
}

interface Messages {
  options: OptionsMessages
}

const useMessages = (): Messages => {
  const { t } = useTranslation()
  return {
    options: t('lookingForOptions', {
      returnObjects: true,
    }) as OptionsMessages,
  }
}

export const HowCanWeHelpStep = (): JSX.Element => {
  const messages = useMessages()
  const { value } = useFormItem('lookingFor')
  const { save, isLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.howCanWeHelp,
  )

  useOnNextClick(save)

  useNextDisabled(() => !value || !value.length, [value])

  useNextLoading(() => isLoading, [isLoading])

  return (
    <FormCardSelect name="lookingFor">
      {keys(messages.options as object).map((item) => (
        <Option key={item} value={item}>
          {messages.options[item]}
        </Option>
      ))}
    </FormCardSelect>
  )
}
